import {z} from '@hono/zod-openapi';

export const VoiceDebugSessionCreateResponseSchema = z
  .object({
    schemaVersion: z.literal('1.0.0'),
    sessionId: z.string().uuid(),
    voiceConversationId: z.string().min(1).max(128).regex(/\S/),
    state: z.literal('connecting'),
    expiresAt: z.string().datetime({offset: true}),
  })
  .strict()
  .openapi('VoiceDebugSessionCreateResponseSchema');

export type VoiceDebugSessionCreateResponse = z.infer<typeof VoiceDebugSessionCreateResponseSchema>;
